import React from "react";
import ReactDOM from "react-dom";
import {RegistrationCallToAction} from "./CallToAction";
import {RegistrationModal} from "./RegistrationModal";

const registrationNode = document.querySelector("#registration");
const registrationModalNode = document.querySelector("#registrationModal");

if (registrationNode) {
    ReactDOM.hydrate(<RegistrationCallToAction
        {...registrationNode.dataset} />, registrationNode);
}

if (registrationModalNode) {
    registrationModalNode.style.display = "none";
    ReactDOM.hydrate(<RegistrationModal {...registrationModalNode.dataset} />, registrationModalNode);
}
